import { createStore } from 'vuex'
import index from './models/index'
import user from './models/user'
import { set } from '@vueuse/core'

const debug = process.env.NODE_ENV !== 'production' 

const state = () => ({
  token: '',
  needLogin: 0,
  globalLoading: false,
  BASE_URL: !debug ? '' : '',
  env_url: 'http://192.168.110.16:8000',
  lan: 'zh-cn',
  leftSideTreeItem: localStorage.leftSideTreeItem ? JSON.parse(localStorage.leftSideTreeItem) : {
    id: '',
    name: ''
  }
})

const getters = {
  getToken(state, getters, rootState) {
    return {
      token: state.token
    }
  },
  getLeftSideTreeItem(state, getters, rootState) {
    return state.leftSideTreeItem
  }
}
const mutations = {
  setLeftSideTreeItem(state, payload) {
    if (payload.type == 'box') {
      state.leftSideTreeItem = payload
      localStorage.leftSideTreeItem = JSON.stringify(payload)
    }
  },
  changeLan (state, payload = 'zh-cn') {
    state.lan = payload
  },
  setToken (state, payload) {
    state.token = payload
  },
  changeGlobalLoading(state, payload) {
    if (typeof payload === 'undefined') {
      state.globalLoading = !state.globalLoading 
    } else {
      if (payload) {
        state.globalLoading = true
      } else {
        state.globalLoading = false
      }
    }
  },
  setNeedLogin (state, payload) {
    state.needLogin = payload
  },
}
const actions = {
  getUserInfo({ commit, state }, products) {
    
  },
  setLeftSideTreeItem({ commit, state }, payload) {
    commit('setLeftSideTreeItem', payload)
  }
}




export default createStore({
  state,
  getters,
  mutations,
  actions,
  modules: {
    index,
    user,
  },
  strict: debug
  // plugins: debug ? [createLogger()] : []
})
